shadow$provide[499] = function(require,module,exports) {
var require$_DOT__SLASH_factory = require("./factory");
var require$_DOT__SLASH_material = require("./material");
var require$_DOT__SLASH_library = require("./library");
var require$_DOT__SLASH_cache = require("./cache");
var require$_DOT__SLASH_queue = require("./queue");
var require$_DOT__SLASH_hash = require("./hash");
require.exportCopy(module, require$_DOT__SLASH_factory);
require.exportCopy(module, require$_DOT__SLASH_material);
require.exportCopy(module, require$_DOT__SLASH_library);
require.exportCopy(module, require$_DOT__SLASH_cache);
require.exportCopy(module, require$_DOT__SLASH_queue);
require.exportCopy(module, require$_DOT__SLASH_hash);

};